/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./v3-game-difficulty-title.vue?vue&type=template&id=e1029b6c&scoped=true&"
import script from "./v3-game-difficulty-title.vue?vue&type=script&lang=js&"
export * from "./v3-game-difficulty-title.vue?vue&type=script&lang=js&"
import style0 from "./v3-game-difficulty-title.vue?vue&type=style&index=0&id=e1029b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1029b6c",
  null
  
)

export default component.exports